import type { ThemeColorsMeta } from '@frameio/vapor';
import { theme } from '@frameio/vapor';

export const isThemeMetaColor = (
  color?: string | null
): color is ThemeColorsMeta => {
  if (color) {
    return Object.keys(theme.colors.meta.opaque).includes(color);
  }
  return false;
};
